
import { useState, useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileSidebar } from "./sidebar/MobileSidebar";
import { DesktopSidebar } from "./sidebar/DesktopSidebar";

export function Sidebar() {
  const [expanded, setExpanded] = useState(true);
  const isMobile = useIsMobile();
  
  // Load sidebar state from localStorage
  useEffect(() => {
    const savedState = localStorage.getItem('sidebarExpanded');
    if (savedState !== null) {
      setExpanded(savedState === 'true');
    }
  }, []);
  
  const toggleSidebar = () => {
    const newState = !expanded;
    setExpanded(newState);
    localStorage.setItem('sidebarExpanded', String(newState));
  };
  
  return (
    <>
      {isMobile ? (
        <MobileSidebar />
      ) : (
        <DesktopSidebar 
          expanded={expanded} 
          toggleSidebar={toggleSidebar}
        />
      )}
    </>
  );
}
